<app-alert [alertType]="AlertTypeEnum.Error" [wide]="wide" [margin]="margin"><ng-content></ng-content></app-alert>